module.exports = __webpack_public_path__ + "media/images/share/email-488def2704b643c2494fcac645c3f490.svg";